/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCommunication = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3.293 1.05a7 7 0 0 0 0 9.9l1.414-1.414a5 5 0 0 1 0-7.071L3.293 1.05zm16.243 1.415a5 5 0 0 1 0 7.07l1.414 1.415a7 7 0 0 0 0-9.9l-1.414 1.415zm-13.122.707a4 4 0 0 0 0 5.656l1.414-1.414a2 2 0 0 1 0-2.828L6.414 3.172zm10 1.414a2 2 0 0 1 0 2.828l1.414 1.414a4 4 0 0 0 0-5.656l-1.414 1.414zm3.629 17.295.062.119h2.262L13.54 5.276a2 2 0 1 0-3.08 0L1.633 22h2.262l.062-.118.003.006L12 17.719l8.04 4.169.003-.007zM14.3 11.001H9.7l2.3-4.36L14.3 11zm-5.655 2h6.71l.301.57L12 15.465 8.344 13.57l.3-.57zm7.945 2.338 1.822 3.452-4.24-2.198 2.418-1.254zM5.588 18.791l1.822-3.452 2.418 1.254-4.24 2.198z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCommunication as Communication };
